import {
  faAngleDown as freeFasFaAngleDown,
  faAngleUp as freeFasFaAngleUp,
  faArrowLeft as freeFasFaArrowLeft,
  faAngleRight as freeFasFaAngleRight,
  faArrowDown as freeFasFaArrowDown,
  faArrowUp as freeFasFaArrowUp,
  faBars as freeFasFaBars,
  faCalendar as freeFasFaCalendar,
  faCaretDown as freeFasFaCaretDown,
  faCaretUp as freeFasFaCaretUp,
  faCheck as freeFasFaCheck,
  faClock as freeFasFaClock,
  faEllipsisVertical as freeFasFaEllipsisVertical,
  faEye as freeFasFaEye,
  faHome as freeFasFaHome,
  faList as freeFasFaList,
  faMagnifyingGlass as freeFasFaMagnifyingGlass,
  faPlus as freeFasFaPlus,
  faRedo as freeFasFaRedo,
  faRemove as freeFasFaRemove,
  faStar as freeFasFaStar,
  faTriangleExclamation as freeFasFaTriangleExclamation,
  faUndo as freeFasFaUndo,
  faUserGroup as freeFasFaUserGroup,
  faTable as freeFasFaTable,
  faCheckCircle as freeFasFaCheckCircle,
  faX as freeFasFaX,
  faSpinner as freeFasFaSpinner,
  faChartSimple as freeFasFaChartSimple,
  faBuilding as freeFasFaBuilding,
  faAward as freeFasFaAward,
  faCompass as freeFasFaCompass,
  faChartPie as freeFasFaChartPie,
  faBook as freeFasFaBook,
  faUsersRectangle as freeFasFaUsersRectangle,
  faBriefcase as freeFasFaBriefcase,
  faLandmark as freeFasFaLandmark,
  faPiggyBank as freeFasFaPiggyBank,
  faGlobe as freeFasFaGlobe,
  faScaleBalanced as freeFasFaScaleBalanced,
  faPrint as freeFasFaPrint,
  faBold as freeFasFaBold,
  faItalic as freeFasFaItalic,
  faListUl as freeFasFaListUl,
  faListOl as freeFasFaListOl,
  faLink as freeFasFaLink,
  faLinkSlash as freeFasFaLinkSlash,
  faEraser as freeFasFaEraser,
  faChevronDown as freeFasFaChevronDown,
  faArrowRight as freeFasFaArrowRight,
  faLocationDot as freeFasFaLocationDot,
  faUniversalAccess as freeFasFaUniversalAccess
} from '@fortawesome/free-solid-svg-icons'

import {
  faArrowUpArrowDown as proFasFaArrowUpArrowDown,
  faArrowUpRightFromSquare as proFasFaArrowUpRightFromSquare,
  faStarSharp as proFasFaStarSharp,
  faCircleInfo as proFasFaCircleInfo,
  faGripDotsVertical as proFasFaGripDotsVertical,
  faInputText as proFasFaInputText,
  faSquareCheck as proFasFaSquareCheck,
  faSignature as proFasFaSignature,
  faPencil as proFasFaPencil,
  faXmarkLarge as proFasFaXmarkLarge,
  faCircleDollar as proFasFaCircleDollar,
  faSidebar as proFasFaSidebar,
  faWindowMaximize as proFasFaWindowMaximize,
  faText as proFasFaText,
  faLock as proFasFaLock,
  faUserCheck as proFasFaUserCheck,
  faXmark as proFasFaXmark,
  faPaperclip as proFasFaPaperclip,
  faUpRightAndDownLeftFromCenter as proFasFaUpRightAndDownLeftFromCenter
} from '@fortawesome/pro-solid-svg-icons'

import {
  faArrowProgress as proFarFaArrowProgress,
  faArrowUpRightFromSquare as proFarFaArrowUpRightFromSquare,
  faBallotCheck as proFarFaBallotCheck,
  faBars as proFarFaBars,
  faCalendar as proFarFaCalendar,
  faCalendarDay as proFarFaCalendarDay,
  faClockRotateLeft as proFarFaClockRotateLeft,
  faEdit as proFarFaEdit,
  faEnvelope as proFarFaEnvelope,
  faEye as proFarFaEye,
  faGavel as proFarFaGavel,
  faGear as proFarFaGear,
  faHammer as proFarFaHammer,
  faHome as proFarFaHome,
  faIdCard as proFarFaIdCard,
  faLink as proFarFaLink,
  faListTree as proFarFaListTree,
  faMicroscope as proFarFaMicroscope,
  faPaperPlaneTop as proFarFaPaperPlaneTop,
  faSend as proFarFaSend,
  faUnlink as proFarFaUnlink,
  faUpload as proFarFaUpload,
  faFilePdf as proFarFaFilePdf,
  faUsersViewfinder as proFarFaUsersViewfinder,
  faChartScatterBubble as proFarFaChartScatterBubble,
  faFolderOpen as proFarFaFolderOpen,
  faDownload as proFarFaDownload,
  faCircleEnvelope as proFarFaCircleEnvelope,
  faTrash as proFarFaTrash,
  faTrashCan as proFarFaTrashCan,
  faEnvelopeCircleCheck as proFarFaEnvelopeCircleCheck,
  faBook as proFarFaBook,
  faChartLine as proFarFaChartLine,
  faChevronDown as proFarFaChevronDown,
  faInputNumeric as proFarFaInputNumeric,
  faFileSignature as proFarFaFileSignature,
  faPen as proFarFaPen,
  faMagnifyingGlassPlus as proFarFaMagnifyingGlassPlus,
  faMagnifyingGlassMinus as proFarFaMagnifyingGlassMinus,
  faMagnifyingGlass as proFarFaMagnifyingGlass,
  faArrowDownToLine as proFarFaArrowDownToLine,
  faCirclePlus as proFarFaCirclePlus,
  faFilter as proFarFaFilter,
  faSquareDashedCirclePlus as proFarFaSquareDashedCirclePlus,
  faCopy as proFarFaCopy,
  faEyeSlash as proFarFaEyeSlash,
  faBookOpen as proFarFaBookOpen,
  faLock as proFarFaLock,
  faPaintbrushPencil as proFarFaPaintbrushPencil,
  faPhone as proFarFaPhone,
  faPlus as proFarFaPlus,
  faGripVertical as proFarFaGripVertical,
  faCircleInfo as proFarFaCircleInfo,
  faFilterCircleXmark as proFarFaFilterCircleXmark,
  faChevronRight as proFarFaChevronRight,
  faChevronLeft as proFarFaChevronLeft,
  faVideo as proFarFaVideo,
  faUserGroup as proFarFaUserGroup,
  faClock as proFarFaClock,
  faLocationDot as proFarFaLocationDot,
  faKey as proFarFaKey,
  faUniversalAccess as proFarFaUniversalAccess
} from '@fortawesome/pro-regular-svg-icons'

import {
  faAddressCard as proFadFaAddressCard,
  faBallotCheck as proFadFaBallotCheck,
  faBook as proFadFaBook,
  faChartLine as proFadFaChartLine,
  faEnvelopeCircleCheck as proFadFaEnvelopeCircleCheck,
  faEyeSlash as proFadFaEyeSlash,
  faIdCard as proFadFaIdCard,
  faInbox as proFadFaInbox,
  faMessageQuestion as proFadFaMessageQuestion,
  faPeopleGroup as proFadFaPeopleGroup,
  faTable as proFadFaTable,
  faArrowUpArrowDown as proFadFaArrowUpArrowDown,
  faSquareDashedCirclePlus as proFadFaSquareDashedCirclePlus
} from '@fortawesome/pro-duotone-svg-icons'

export default {freeFasFaAngleDown, freeFasFaAngleUp, freeFasFaArrowLeft, freeFasFaAngleRight, freeFasFaArrowDown, freeFasFaArrowUp, freeFasFaBars, freeFasFaCalendar, freeFasFaCaretDown, freeFasFaCaretUp, freeFasFaCheck, freeFasFaClock, freeFasFaEllipsisVertical, freeFasFaEye, freeFasFaHome, freeFasFaList, freeFasFaMagnifyingGlass, freeFasFaPlus, freeFasFaRedo, freeFasFaRemove, freeFasFaStar, freeFasFaTriangleExclamation, freeFasFaUndo, freeFasFaUserGroup, freeFasFaTable, freeFasFaCheckCircle, freeFasFaX, freeFasFaSpinner, freeFasFaChartSimple, freeFasFaBuilding, freeFasFaAward, freeFasFaCompass, freeFasFaChartPie, freeFasFaBook, freeFasFaUsersRectangle, freeFasFaBriefcase, freeFasFaLandmark, freeFasFaPiggyBank, freeFasFaGlobe, freeFasFaScaleBalanced, freeFasFaPrint, freeFasFaBold, freeFasFaItalic, freeFasFaListUl, freeFasFaListOl, freeFasFaLink, freeFasFaLinkSlash, freeFasFaEraser, freeFasFaChevronDown, freeFasFaArrowRight, freeFasFaLocationDot, freeFasFaUniversalAccess, proFasFaArrowUpArrowDown, proFasFaArrowUpRightFromSquare, proFasFaStarSharp, proFasFaCircleInfo, proFasFaGripDotsVertical, proFasFaInputText, proFasFaSquareCheck, proFasFaSignature, proFasFaPencil, proFasFaXmarkLarge, proFasFaCircleDollar, proFasFaSidebar, proFasFaWindowMaximize, proFasFaText, proFasFaLock, proFasFaUserCheck, proFasFaXmark, proFasFaPaperclip, proFasFaUpRightAndDownLeftFromCenter, proFarFaArrowProgress, proFarFaArrowUpRightFromSquare, proFarFaBallotCheck, proFarFaBars, proFarFaCalendar, proFarFaCalendarDay, proFarFaClockRotateLeft, proFarFaEdit, proFarFaEnvelope, proFarFaEye, proFarFaGavel, proFarFaGear, proFarFaHammer, proFarFaHome, proFarFaIdCard, proFarFaLink, proFarFaListTree, proFarFaMicroscope, proFarFaPaperPlaneTop, proFarFaSend, proFarFaUnlink, proFarFaUpload, proFarFaFilePdf, proFarFaUsersViewfinder, proFarFaChartScatterBubble, proFarFaFolderOpen, proFarFaDownload, proFarFaCircleEnvelope, proFarFaTrash, proFarFaTrashCan, proFarFaEnvelopeCircleCheck, proFarFaBook, proFarFaChartLine, proFarFaChevronDown, proFarFaInputNumeric, proFarFaFileSignature, proFarFaPen, proFarFaMagnifyingGlassPlus, proFarFaMagnifyingGlassMinus, proFarFaMagnifyingGlass, proFarFaArrowDownToLine, proFarFaCirclePlus, proFarFaFilter, proFarFaSquareDashedCirclePlus, proFarFaCopy, proFarFaEyeSlash, proFarFaBookOpen, proFarFaLock, proFarFaPaintbrushPencil, proFarFaPhone, proFarFaPlus, proFarFaGripVertical, proFarFaCircleInfo, proFarFaFilterCircleXmark, proFarFaChevronRight, proFarFaChevronLeft, proFarFaVideo, proFarFaUserGroup, proFarFaClock, proFarFaLocationDot, proFarFaKey, proFarFaUniversalAccess, proFadFaAddressCard, proFadFaBallotCheck, proFadFaBook, proFadFaChartLine, proFadFaEnvelopeCircleCheck, proFadFaEyeSlash, proFadFaIdCard, proFadFaInbox, proFadFaMessageQuestion, proFadFaPeopleGroup, proFadFaTable, proFadFaArrowUpArrowDown, proFadFaSquareDashedCirclePlus}